import { mount } from '../dom-lifecycle';

// Pola w ukrytych wierszach (`.c-form__row--hidden`) — NIP sprzedawcy, numer
// kasy, wartość produktów promocyjnych — są wyłącznie informacyjne dla admina:
// wypełnia je OCR paragonu (receipt.js), a użytkownik ich nie widzi i nie ma
// jak nic w nich poprawić.
//
// Dlatego zdejmujemy z nich WSZYSTKO, co mogłoby oblać `checkValidity()` przy
// wysyłce (validation.js). Niespełniony warunek na niewidocznym polu = formularz
// cicho się nie wysyła i nie ma czego podświetlić — najgorszy możliwy scenariusz.
// To zabezpieczenie na wypadek, gdyby ktoś dołożył walidację w metadanych
// workflow albo w form_defaults.yaml; pola muszą jechać z formularzem, ale
// nigdy nie mogą go zablokować.
mount('.c-form__row--hidden input, .c-form__row--hidden select, .c-form__row--hidden textarea', function () {
	this.required = false;
	['pattern', 'min', 'max', 'minlength', 'maxlength'].forEach(attr => this.removeAttribute(attr));
	// `type=number` bez `step` przyjmuje tylko liczby całkowite, a z OCR-a
	// przychodzi np. „12.5" — `step=any` znosi `stepMismatch`. Typu NIE zmieniamy
	// na `text`: przy złej wartości `type=number` odsyła pustą wartość, a nie
	// błąd transformacji MoneyType, który znów zablokowałby wysyłkę.
	if ('number' === this.type) {
		this.step = 'any';
	}
	this._customValidity?.clear();
	this.setCustomValidity('');
});
